import { action } from 'mobx';

import { AppManager } from 'core/index';

import {
  ForumsConnManager,
  ThreadConnManager,
} from 'apps/forum/main/appManager';
import { FeaturedForumsQuery, AllThreadsQuery } from 'apps/forum/gql';

export class ConnectConversationsManager extends AppManager {
  constructor(parent, init = {}) {
    super(parent, init);
    this.featuredForumsConn = new ForumsConnManager(this, {
      contains: ['featured_in', 'featured_forums'],
      loadMoreQuery: FeaturedForumsQuery,
      batchSize: 3,
    });
    this.threadsConn = new ThreadConnManager(this, {
      sortBy: 'recent',
      initialBatchSize: 18,
      batchSize: 12,
      loadMoreQuery: AllThreadsQuery,
    });
    this.Query();
  }

  @action Query = () => {
    this.threadsConn.loadMore();
    this.featuredForumsConn.loadMore();
  };
}
